import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterFileListWithName',
})
export class FilterFileListWithName implements PipeTransform {
  transform(list: any[], searchString = ''): any[] {
    if (searchString.length == 0) {
      return list;
    } else {
      let newList = list.filter((x) => x.file_name?.toLowerCase().includes(searchString.toLowerCase()));
      return newList;
    }
  }
}
